export class InvalidStateException extends Error {
  constructor(...args) {
    super(...args);
    Error.captureStackTrace(this, InvalidStateException);
  }
}

export const graphQlToFormErrors = e => {
  // we actually don't know wht message we get for specification
  // CHANGE LATER: throwing the BE error as is for developers for now
  const message =
    e.graphQLErrors && e.graphQLErrors.find(error => error.message);
  return (message && message.message) || e.toString();
};
